import React from 'react';
import Index from '../features/orders/components/UserOrders';

const UserOrdersPage = () => {
  return <Index />;
};

export default UserOrdersPage;
